module.exports = "/_next/static/images/ScanPreview3-1a1bae973315113efea067b6e4bc5e94.png";